import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const CONTROL_HEIGHT = 40;

export const Form = styled("form")<{ $small: boolean; $stacked?: boolean }>(
  ({ $small, $stacked }) => {
    const isInline = $small && !$stacked;

    return {
      width: "100%",
      display: "flex",
      flexDirection: $stacked || !$small ? "column" : "row",
      alignItems: $stacked || !$small ? "stretch" : "flex-start",
      gap: $stacked ? "0.75rem" : $small ? "0.5rem" : "1.5rem",
      ...(isInline && {
        "& .MuiInputBase-root": { height: CONTROL_HEIGHT },
      }),
      ...((isInline || $stacked) && {
        "& .MuiButton-root": { height: CONTROL_HEIGHT },
      }),
    };
  }
);

export const Wrapper = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;
